import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { 
  FiHome, FiGrid, FiFileText, FiBook, 
  FiSettings, FiLogOut, FiInfo
} from 'react-icons/fi';
import { HiQrcode } from 'react-icons/hi';
import { useAuth } from '../context/AuthContext';

const AdminLayout = () => {
  const location = useLocation();
  const { logout, user } = useAuth();

  const navigation = [
    { name: 'Dashboard', href: '/admin/dashboard', icon: FiHome },
    { name: 'Categories', href: '/admin/categories', icon: FiGrid },
    { name: 'Sections', href: '/admin/sections', icon: FiFileText },
    { name: 'Guest Book', href: '/admin/guestbook', icon: FiBook },
    { name: 'Quick Info', href: '/admin/quick-info', icon: FiInfo },
    { name: 'Settings', href: '/admin/settings', icon: FiSettings },
    { name: 'QR Codes', href: '/admin/qr-codes', icon: HiQrcode },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <div className="w-64 bg-lodge-brown-800 flex-shrink-0">
          <div className="h-full flex flex-col">
            <div className="flex items-center justify-between px-4 py-4 bg-lodge-brown-900">
              <h2 className="text-xl font-bold text-white">Admin Panel</h2>
              <Link 
                to="/" 
                className="text-lodge-brown-300 hover:text-white transition-colors"
                title="View Site"
              >
                <FiHome size={20} />
              </Link>
            </div>
            
            <nav className="flex-1 px-2 py-4 space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive(item.href)
                      ? 'bg-lodge-brown-900 text-white'
                      : 'text-lodge-brown-100 hover:bg-lodge-brown-700 hover:text-white'
                  }`}
                >
                  <item.icon className="mr-3 h-5 w-5 flex-shrink-0" />
                  {item.name}
                </Link>
              ))}
            </nav>

            <div className="p-4 border-t border-lodge-brown-700">
              <div className="text-sm text-lodge-brown-300 mb-2">
                Logged in as: {user?.username}
              </div>
              <button
                onClick={logout}
                className="flex items-center w-full px-2 py-2 text-sm font-medium text-lodge-brown-100 hover:bg-lodge-brown-700 hover:text-white rounded-md transition-colors"
              >
                <FiLogOut className="mr-3 h-5 w-5" />
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 overflow-auto">
          <main className="p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;